import React from 'react'
import { useActiveWeb3React } from '../../../../../hooks'
import { YTS } from '../../../../../constants'

import {
  CardNavLink,
  NFTCardImage,
  NFTCardMeta,
  NFTCardPrice,
  NFTCardTitle,
  NFTCardView
} from '../../../components/NFTCard/syled'
import { IBaseCard } from '../../../components/NFTCard/INFTCard'
import { useGetSaleTokenItem, useGetNFTPrice } from '../../../../../hooks/useNFTMarketPlace'
import NFTCardButtons from '../../Default/components/NFTCardButtons/NFTCardButtons'
import NFTPriceSymbol from '../../../components/NFTPriceSymbol'

export default function BaseCard(props: IBaseCard) {
  const {
    token,
    tokenId,
    collection,
    detailUrl,
    setSale,
    transferNFT,
    approve,
    buyNow,
    isSale,
    isWallet,
    removeSale,
    approveState,
    account,
    saleToken,
    owner,
    tokenName,
    children
  } = props
  const { chainId } = useActiveWeb3React()

  const yts = chainId !== undefined ? YTS[chainId] : undefined
  const NFTTokenPrice: string = useGetNFTPrice(token?.price, yts)
  const saleTokenItem = useGetSaleTokenItem(saleToken)

  const tokenLink = `${detailUrl}/${collection.tokenAddress}/${tokenId}`

  return (
    <NFTCardView className="nft-card-view">
      <NFTCardImage>{children}</NFTCardImage>
      <NFTCardMeta>
        <CardNavLink to={tokenLink}>
          <NFTCardTitle title={tokenName}>{tokenName}</NFTCardTitle>
          {isSale ? (
            <NFTCardPrice>
              {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
            </NFTCardPrice>
          ) : (
            'Not For Sale'
          )}
        </CardNavLink>
      </NFTCardMeta>
      <NFTCardButtons
        tokenContractAddress={collection.tokenAddress}
        tokenId={tokenId}
        isWallet={isWallet}
        token={token}
        setSale={setSale}
        approve={approve}
        buyNow={buyNow}
        isSale={isSale}
        tokenName={tokenName}
        removeSale={removeSale}
        transferNFT={transferNFT}
        approveState={approveState}
        account={account}
        saleToken={saleToken}
        owner={owner}
      />
    </NFTCardView>
  )
}
